import { Modal, PDFRenderer } from "components";
import { classNames, getAccountPeriodLabel } from "utils";
import { useMatch, useSearch } from "react-location";

import { LocationGenerics } from "router/location";
import { Switch } from "@headlessui/react";
import _ from "lodash";
import config from "config";
import { useCurrentUser } from "_graphql/cache/auth";
import { useState } from "react";
import { useTreatyAccounts } from "hooks/data/use-treaties";

export default function ViewTreatyDebitNoteContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  useMatch<LocationGenerics>();
  const [isDefualt, setDefualt] = useState(true);
  const currentUSer = useCurrentUser();

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="6xl"
      title={"Debit Note"}
      hidePadding
      description={`Details of Debit Note are shown below`}
    >
      <div className="col-span-2 p-7">
        <Switch.Group as="div">
          <span className="flex flex-grow flex-col">
            <Switch.Label
              as="span"
              className="text-sm font-medium text-gray-900"
              passive
            >
              Default Debit Note
            </Switch.Label>
          </span>
          <div className="flex items-center justify-between h-[38px]">
            <Switch.Description as="span" className="text-sm text-gray-500">
              Toggle the above switch to compile related debits for the{" "}
              {getAccountPeriodLabel(searchParams?.quarter || "")}
            </Switch.Description>
            <Switch
              checked={isDefualt}
              onChange={setDefualt}
              className={classNames(
                isDefualt ? "bg-primary-600" : "bg-gray-200",
                "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
              )}
            >
              <span
                aria-hidden="true"
                className={classNames(
                  isDefualt ? "translate-x-5" : "translate-x-0",
                  "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                )}
              />
            </Switch>
          </div>
        </Switch.Group>
      </div>
      <PDFRenderer
        url={`${config.asset.uri}treaty_debit_note/${btoa(
          JSON.stringify({
            treaty_account_id: searchParams?.treaty_account_id,
            default: isDefualt,
            emp_id: currentUSer?.employee?.employee_id,
          })
        )}`}
      />
    </Modal>
  );
}
